// Tail.js component with copy rights and Years
import React from 'react';
const Tail = () => {
    return (
        <div className="text-center mt-3">
        <p>
            <small className='align-items-center'>
            <a href="https://www.pic-loud.com">
            <img src="/logo_horizontal.png" alt="Pic-loud" style={{ width: "auto", height: "18px" }}/>

            </a> | {" "}
            &copy; {new Date().getFullYear()}{" "}
            {/* <a href="https://www.pic-loud.com/privacy">Privacy</a> |{" "} */}
            | {" "}
            <a href="https://www.pic-loud.com/terms">Terms</a>
            </small>
        </p>
        </div>
    );
}

export default Tail;